/** Идентификатор блока общего домашнего задания в списке отправки. */
export const HOMEWORK_ASSIGNMENT_ID = 'homework';
